<div [ngClass]="dbPage ? 'seat-limit-error-page without-padding-top' : 'seat-limit-error-page'">
  <!-- <mode-confetti-layout *ngIf="!(orgSeatLimitReached)">
    <mode-error-prompt
      [title]="errorTitle"
      [explanation]="errorExplanation"
      [instructions]="errorInstructions">
      <mode-error-prompt-actions>
        <capra-button-link
          *ngIf="!hasNoSecondary"
          class="btn btn-secondary btn-lg margin-right-10"
          variant="secondary"
          [text]="errorSecondaryActionLabel"
          [href]="errorSecondaryActionTarget"
        ></capra-button-link>
        <mode-calendly-popup-button>
          <button class="btn btn-lg btn-primary">{{ errorPrimaryActionLabel }}</button>
        </mode-calendly-popup-button>
      </mode-error-prompt-actions>
    </mode-error-prompt>
  </mode-confetti-layout> -->

  <div class="error-prompt-wrapper" *ngIf="!dbPage">
    <div class="avatar-container">
      <div class="avatars">
        <capra-icon class="group-icon" icon="illo-mask-group-1"></capra-icon>
        <capra-icon class="group-icon" icon="illo-mask-group-2"></capra-icon>
        <capra-icon class="group-icon" icon="illo-mask-group-3"></capra-icon>
        <capra-icon class="group-icon" icon="illo-mask-group-4"></capra-icon>
        <capra-icon class="group-icon" icon="illo-mask-group-5"></capra-icon>
        <div class="invite-btn-container">
          <span class="invite-text"> Invite </span>
        </div>
        <capra-icon class="arrow-icon" icon="illo-arrow"></capra-icon>
      </div>
    </div>
    <mode-error-prompt [title]="errorTitle" [instructions]="errorInstructions" [setCustomCss]="true">
      <mode-error-prompt-actions class="error-prompt-actions-container">
        <capra-button-link
          *ngIf="!hasNoSecondary"
          class="btn btn-secondary btn-lg margin-right-10 back"
          variant="secondary"
          [text]="errorSecondaryActionLabel"
          [href]="errorSecondaryActionTarget"
        ></capra-button-link>
        <mode-calendly-popup-button>
          <button class="btn btn-lg btn-primary upgrade">{{ errorPrimaryActionLabel }}</button>
        </mode-calendly-popup-button>
      </mode-error-prompt-actions>
    </mode-error-prompt>
  </div>

  <div class="error-prompt-wrapper without-padding" *ngIf="dbPage">
    <div class="avatar-container db-page-avatars">
      <div class="avatars db-page">
        <capra-icon class="group-icon db-page" icon="illo-mask-group-1"></capra-icon>
        <capra-icon class="group-icon db-page" icon="illo-mask-group-2"></capra-icon>
        <capra-icon class="group-icon db-page" icon="illo-mask-group-3"></capra-icon>
        <capra-icon class="group-icon db-page" icon="illo-mask-group-4"></capra-icon>
        <capra-icon class="group-icon db-page" icon="illo-mask-group-5"></capra-icon>
        <div class="invite-btn-container">
          <span class="invite-text"> Invite </span>
        </div>
        <capra-icon class="arrow-icon" icon="illo-arrow"></capra-icon>
      </div>
    </div>
    <mode-error-prompt
      [title]="errorTitle"
      [instructions]="errorInstructions"
      [setCustomCss]="true"
      class="db-page-desc"
    >
      <mode-error-prompt-actions class="error-prompt-actions-container db-page db-action">
        <capra-button-link
          *ngIf="!hasNoSecondary"
          class="btn btn-secondary btn-lg margin-right-10 back"
          variant="secondary"
          [text]="errorSecondaryActionLabel"
          [href]="errorSecondaryActionTarget"
        ></capra-button-link>
        <mode-calendly-popup-button>
          <button class="btn btn-lg btn-primary upgrade">{{ errorPrimaryActionLabel }}</button>
        </mode-calendly-popup-button>
      </mode-error-prompt-actions>
    </mode-error-prompt>
  </div>
</div>
